import React, { useState, useMemo } from "react";
import axios from "axios";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import "./Dashboard.css";
import api from "../utils/api";


const policyOk = (pw) => /^(?=.*[A-Za-z])(?=.*\d).{8,}$/.test(pw);

export default function ResetPassword() {
  const [params] = useSearchParams();
  const rid = params.get("rid");
  const t = params.get("t");
  const navigate = useNavigate();

  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const policyHelp = "Use at least 8 characters with letters and numbers.";

  const canSubmit = useMemo(
    () => !!rid && !!t && policyOk(pw) && pw === pw2 && !submitting,
    [rid, t, pw, pw2, submitting]
  );

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setErr("");

    if (!rid || !t) {
      setErr("This reset link is invalid.");
      return;
    }
    if (!policyOk(pw)) {
      setErr(policyHelp);
      return;
    }
    if (pw !== pw2) {
      setErr("Passwords do not match.");
      return;
    }

    try {
      setSubmitting(true);
      await api.post("/auth/reset-password", {
        rid,
        t,
        newPassword: pw,
      });
      setMsg("✅ Password updated. Redirecting to login…");
      setTimeout(() => navigate("/seller/login"), 1200);
    } catch (e) {
      const apiErr = e?.response?.data?.error || "Could not reset password.";
      setErr(apiErr);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page center-wrap">
      {msg && <div className="toast">{msg}</div>}
      {err && <div className="toast error">{err}</div>}

      <section className="card" style={{ maxWidth: 420, margin: "2rem auto" }}>
        <h2>Set a new password</h2>
        {!rid || !t ? (
          <>
            <p className="muted">Your reset link is missing or invalid.</p>
            <Link to="/forgot-password" className="btn">
              Get a new link
            </Link>
          </>
        ) : (
          <form onSubmit={onSubmit} className="add-form" noValidate>
            <label>
              <input
                type="password"
                name="newPassword"
                placeholder="New password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
              />
              <small className="hint">{policyHelp}</small>
            </label>

            <label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm new password"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                required
              />
            </label>

            <button className="btn" type="submit" disabled={!canSubmit}>
              {submitting ? "Updating…" : "Update password"}
            </button>

            <div style={{ marginTop: "1rem" }}>
              <Link to="/login" className="muted">
                ← Back to login
              </Link>
            </div>
          </form>
        )}
      </section>
    </div>
  );
}

